export default function Home() {
  return (
    <div id="container" style={{ paddingTop: '8em', paddingLeft: '2em' }}>
      <img 
        src="/images/mainengine_2015_logo_comprido.jpg" 
        style={{ position: 'relative', left: '4px', width: '692px', height: 'auto', zIndex: 1, textAlign: 'left' }}
        alt="Logo Mainengine"
      />
      <div style={{ paddingTop: '2em' }}>
        <p style={{ fontSize: '1.2em', color: '#333' }}>
          Bem-vindo à MainEngine - Consultoria em Soluções de Sistemas
        </p>
      </div>
    </div>
  )
}
